export default function SupportPage() {
  return (
    <div>
      <p>Support page</p>
    </div>
  )
};
